export default __webpack_public_path__ + "static/media/caution-sign.f5c02ea5.svg";